import React, { useCallback, useEffect, useRef, useState } from 'react';
import Layouts from '../../components/Layouts';
import { AutoComplete, Button, Col, Flex, Form, Input, Modal, Row, Space } from 'antd';
import { PageContainer, ProDescriptions } from '@ant-design/pro-components';
import { getCity, getCountry, searchCity, searchCountry, updateCountry } from '../../store/bids';
import socket from '../../socket';
import { useDispatch } from 'react-redux';
import CountryRow from './CountryRow';
import { useTranslation } from 'react-i18next';

export interface City {
  key: string;
  title: string;
  country: string;
  dataIndex: string;
  similar: boolean;
}


const Country = () => {
  const actionRef = useRef<any>();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [cities, setCities] = useState<City[]>([]);
  const [editingCityKey, setEditingCityKey] = useState<string | null>(null);
  const [inputValue, setInputValue] = useState<string>('');
  const [inputValueOld, setInputValueOld] = useState<string>('');
  const [filteredCountries, setFilteredCountries] = useState<City[]>([]);
  const [isOpenRefCountry, setIsOpenRefCountry] = useState(false);
  const [optionCities, setOptionCities] = useState<City[]>([]);
  const [optionCountry, setOptionCountry] = useState<City[]>([]);
  const [langs, setLangs] = useState<string>();
  const locale: any = localStorage.getItem('i18nextLng');

  useEffect(() => {
    if (locale) {
      setLangs(locale);
    } else {
      setLangs(locale);
    }
    i18n.changeLanguage(langs).then((r) => {
      dispatch(getCountry({locale: locale}));
    });

    socket.on('return-get-country', resCountry);
    socket.on('return-update-country', resUpdateCountry);

    return () => {
      socket.off('return-get-country', resCountry);
      socket.off('return-update-country', resUpdateCountry);
    };
  }, [dispatch]);

  const resUpdateCountry = (response: any) => {
    setCities([]);
    setFilteredCountries(response);
  };

  const resCountry = (response: any) => {
    setCities(response);
    setFilteredCountries(response)
  };

  const handleEdit = useCallback((city: City) => {
    setEditingCityKey(city.key);
    setInputValue(city.title);
    setInputValueOld(city.title);
  }, []);

  const handleSave = useCallback(() => {
    dispatch(updateCountry({ id: editingCityKey, text: inputValue, old: inputValueOld, locale: langs }));
    setEditingCityKey(null);
  }, [inputValue]);

  const handleCancel = useCallback(() => {
    setEditingCityKey(null);
  }, []);

  const handleSearchCountry = (value: string) => {
    const filtered = cities.filter(city =>
      city.title.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCountries(filtered);
  };

  const handleCancelRefCountry = () => {
    setIsOpenRefCountry(false);
  }

  const handleOkRefCountry = () => {

  }

  const onSearchCity = (e: string) => {
    if (e.length > 2) {
      dispatch(searchCity(e));
    }
  };

  const onSearchCountry = (e: string) => {
    if (e.length > 2) {
      dispatch(searchCountry(e));
    }
  };

  const handleAddCountry = () => {
    setIsOpenRefCountry(true)
  }

  return (
    <Layouts>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <PageContainer style={{ overflow: 'scroll', height: '93vh' }}>
          <Flex vertical gap={10}>
            <Flex gap={10} justify={'space-between'}>
              <Input placeholder={t('CountrySearch')} style={{ width: '20%' }}
                     onChange={(e) => handleSearchCountry(e.target.value)}/>
              <Button type="primary" onClick={handleAddCountry}>{t('Add')}</Button>
            </Flex>
            <ProDescriptions actionRef={actionRef} column={3} bordered>
              {filteredCountries.map(city => (
                <ProDescriptions.Item key={city.key} dataIndex={city.dataIndex} title={city.country}
                                      style={{ padding: '3px 22px' }}>
                  <CountryRow
                    key={city.key}
                    city={city}
                    isEditing={editingCityKey === city.key}
                    onEdit={() => handleEdit(city)}
                    onSave={handleSave}
                    onCancel={handleCancel}
                    inputValue={inputValue}
                    setInputValue={setInputValue} />
                </ProDescriptions.Item>
              ))}
            </ProDescriptions>
          </Flex>
        </PageContainer>
        <Modal open={isOpenRefCountry} centered title={t('AddСountry')}
               width={700} footer={false} onCancel={handleCancelRefCountry}>
          <Form onFinish={handleOkRefCountry}>
            <Row justify={'space-between'} gutter={20}>
              <Col span={12} style={{ marginBottom: 10 }}>
                <Form.Item name={'city'} rules={[{ required: true, message: t('RequiredField') }]}>
                  <AutoComplete
                    placeholder={t('City')}
                    style={{ width: '100%' }}
                    showSearch
                    allowClear
                    onSearch={onSearchCity}
                    notFoundContent={null}
                    options={optionCities.map((d: any) => ({ value: d.city, label: d.city }))}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ marginBottom: 10 }}>
                <Form.Item name={'country'} rules={[{ required: true, message: t('RequiredField') }]}>
                  <AutoComplete
                    placeholder={t('Country')}
                    style={{ width: '100%' }}
                    showSearch
                    allowClear
                    onSearch={onSearchCountry}
                    notFoundContent={null}
                    options={optionCountry.map((d: any) => ({ value: d.country, label: d.country }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Flex gap={10} justify={'flex-end'}>
              <Button onClick={handleCancelRefCountry}>{t('Cancel')}</Button>
              <Button type={'primary'} htmlType={'submit'}>OK</Button>
            </Flex>
          </Form>
        </Modal>
      </Space>
    </Layouts>
  );
};

export default Country;